(function(angular){
	'use strict';
	
	angular
		.module('viewReitElementModule', [
			'apiModule',
			'coreModule',
			'mapboxGLModule',
			'mediaGalleryModule',
			'reitElementListingModule',
			'riskAdjustedReturnModule'
		])
		.value('globalConfig', globalConfig);

})(window.angular);